import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { buildUrlWithQueryParams } from '../utils/buildUrlWithQueryParams';

interface StorySlide {
    id: string;
    header: string;
    description: string;
    image: string;
    theme: 'primary' | 'inverse';
    order: number;
    action_type?: 'link';
    action_data?: {
        title?: string;
        url: string;
    };
}
interface StoriesFromCms {
    id: string;
    header: string;
    description: string;
    image: {
        desktop: string; // В учебнике юзаем только эту
        mobile?: string; // nullable
    };
    color: string; // так же может быть в виде linear-gradient(90deg, rgba(255,255,255,1) 25%, rgba(214,233,160,1) 100%)
    theme: 'primary' | 'inverse';
    priority: number; // чем больше число - тем раньше показываем
    is_published: boolean; // по идее здесь всегда будет true
    date_start: string; // null или строка с датой
    date_expired: string; // null или строка с датой
    action_type: 'link'; // Кнопка. link если ссылка, null если пусто
    action_data: {
        title: string;
        url: string;
    };
    slides: StorySlide[];
}

interface GetStoriesParams {
    grades?: number[];
    subjects?: string[];
}
export function getStories({ subjects = [], grades = [] }: GetStoriesParams = {}): Promise<StoriesFromCms[]> {
    const { apiGetStories } = apiConfig.getStaticUrls();
    const url = buildUrlWithQueryParams(apiGetStories, { subjects, grades });
    return getFetch(url);
}
